import { render, staticRenderFns } from "./CreatePurchaseOtherPayment.vue?vue&type=template&id=20dafb96"
import script from "./CreatePurchaseOtherPayment.vue?vue&type=script&lang=js"
export * from "./CreatePurchaseOtherPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports